export class GeneralUtil {
  static toMoney(amount?: number) {
    if (!amount) return 0
    return new Intl.NumberFormat('de-DE').format(amount)
  }
}
